<template>
  <button
    type="button"
    :class="computedClasses"
    :style="computedStyles"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'MpnBasicButton',
  props: {
    title: {
      type: String,
      default: 'Click',
    },
    size: {
      type: String,
      default: 'medium',
    },
    fixedWidth: {
      type: Number,
      default: -1,
    },
    color: {
      type: String,
      default: 'white',
    },
    hideOnMobile: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedStyles() {
      if (this.fixedWidth > -1) {
        return [{
          width: `${this.fixedWidth}px`,
          minWidth: `${this.fixedWidth}px`,
          maxWidth: `${this.fixedWidth}px`,
        }];
      }
      return [];
    },
    computedClasses() {
      const r = [];
      // color check
      switch (this.color) {
        case 'white': r.push('btn_default-a'); break;
        case 'navy': r.push('btn_default-b'); break;
        case 'gray': r.push('btn_default-f'); break;
        default: r.push('btn_default-a');
      }
      // size check
      r.push(this.size);

      // mobile option check
      if (this.hideOnMobile) {
        r.push('mo_hidden');
      }

      return r;
    },
  },
};
</script>
